import { render, staticRenderFns } from "./SGKExitApprovalView.vue?vue&type=template&id=09cfdbe2&"
import script from "./SGKExitApprovalView.vue?vue&type=script&lang=js&"
export * from "./SGKExitApprovalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports